
export function deepClone(object: any) {
    return JSON.parse(JSON.stringify(object));
}

export function deleteUndefinedFields(object: Object) {
    for (const key of Object.keys(object)) {
        if (object[key] === undefined) {
            delete object[key];
        }
    }
}

export function toObject<T>(array: T[], key: (item: T) => string): { [id: string]: T } {
    return array.reduce((acc, item) => (acc[key(item)] = item, acc), {});
}